import { r2Fetch } from './client';

export interface R2ReferenceResolveParams {
  bucket_id: string;
  key: string;
}

export interface R2ReferenceResolveResponse {
  url: string;
}

export async function r2ReferenceResolve(
  params: R2ReferenceResolveParams
): Promise<R2ReferenceResolveResponse> {
  return r2Fetch<R2ReferenceResolveResponse>('/rpc/r2_reference_resolve', {
    body: params,
  });
}
